import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse, IApiQueryOptions } from 'api/ApiClient';
import { IAction, IApiList, ILedgerEntry } from 'types';
import * as API from '../../../api';
import * as Actions from './actions';
import * as ActionTypes from './types';

interface ILedgerPayload {
  siteId: string;
  startDate: string;
  endDate: string;
  options?: IApiQueryOptions;
}

export function* getPrefundLedger({ payload }: IAction<ActionTypes.Ledger, ILedgerPayload>) {
  try {
    const response: ApiResponse<IApiList<ILedgerEntry>> = yield call(API.Sites.listPrefundLedgerEntries, payload.siteId, payload.startDate, payload.endDate, payload.options);

    yield put(Actions.getPrefundLedgerSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getPrefundLedgerError(error));
  }
}

export function* watchGetPrefundLedger() {
  yield takeEvery(ActionTypes.Ledger.GET_PREFUND_LEDGER_REQUEST, getPrefundLedger);
}

function* ledgersSaga() {
  yield all([fork(watchGetPrefundLedger)]);
}
export { ledgersSaga };
